import React from 'react';
import FaiBox from "../../../MuiComponents/FaiBox";
import Strip from "../../../components/Strip";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import theme from "../../../assets/theme";
import {Grid} from "@mui/material";
import FaiDropzone from "../../../MuiComponents/FaiDropzone";
import orderIssueImg from "../../../assets/images/order_issue_img.jpg";
import ProductDetail from "../components/ProductDetail";

function ClosedIssues(props) {
    const {typography, palette, borders, boxShadows} = theme
    return (
        <>
            <FaiBox>
                <FaiBox mb={2}>
                    <Strip>
                        <FaiBox display={"flex"} justifyContent={"center"} alignItem={"center"} py={2}>
                            <FaiTypography variant={"h3"} fontWeight={typography.fontWeightBold}>
                                How can we help you?
                            </FaiTypography>
                        </FaiBox>
                    </Strip>
                </FaiBox>
                <FaiBox bgColor={palette.white.main} className={"coupon-form-content"} p={"15px"}
                        borderRadius={borders.borderRadius.md}>

                    <FaiBox>
                        <Grid container>
                            <Grid item sm={12} md={6} lg={6}>
                                <FaiBox mb={2}>
                                    <FaiTypography variant={"h4"} fontWeight={typography.fontWeightMedium}>
                                        Order related issues
                                    </FaiTypography>
                                </FaiBox>
                                <FaiBox>
                                    <FaiBox mb={1}>
                                        <FaiBox ml={0.5}>
                                            <FaiBox mb={0.5} ml={0.5} lineHeight={0} display="inline-block">
                                                <FaiBox>
                                                    <FaiTypography
                                                        component="label"
                                                        variant="subtitle2"
                                                        fontWeight="bold"
                                                        textTransform="capitalize"
                                                    >
                                                        Order Id
                                                    </FaiTypography>
                                                </FaiBox>
                                            </FaiBox>
                                        </FaiBox>

                                        <FaiBox sx={{
                                            boxShadow: boxShadows.sm,
                                            padding: "5px 0 5px 12px",
                                            borderRadius: borders.borderRadius.sm
                                        }}>
                                            <FaiTypography variant={"button"}>
                                                1201
                                            </FaiTypography>
                                        </FaiBox>
                                    </FaiBox>
                                    <FaiBox mb={1}>
                                        <FaiBox ml={0.5}>
                                            <FaiBox lineHeight={0} display="inline-block">
                                                <FaiBox>
                                                    <FaiTypography
                                                        component="label"
                                                        variant="subtitle2"
                                                        fontWeight="bold"
                                                        textTransform="capitalize"
                                                    >
                                                        What is the issue related to product
                                                    </FaiTypography>
                                                </FaiBox>
                                            </FaiBox>
                                        </FaiBox>
                                        <FaiBox sx={{
                                            boxShadow: boxShadows.sm,
                                            padding: "5px 0 5px 12px",
                                            borderRadius: borders.borderRadius.sm
                                        }}>
                                            <FaiTypography variant={"button"}>
                                                The returned product is worn out
                                            </FaiTypography>
                                        </FaiBox>
                                    </FaiBox>
                                    <FaiBox mb={1}>
                                        <FaiBox ml={0.5}>
                                            <FaiBox lineHeight={0} display="inline-block">
                                                <FaiBox>
                                                    <FaiTypography
                                                        component="label"
                                                        variant="subtitle2"
                                                        fontWeight="bold"
                                                        textTransform="capitalize"
                                                    >
                                                        Uploaded Document
                                                    </FaiTypography>
                                                </FaiBox>
                                            </FaiBox>
                                        </FaiBox>
                                        <FaiBox>
                                            <FaiBox component={"img"} src={orderIssueImg}/>
                                        </FaiBox>
                                    </FaiBox>
                                    <FaiBox mb={3}>
                                        <FaiBox ml={0.5}>
                                            <FaiBox lineHeight={0} display="inline-block">
                                                <FaiBox>
                                                    <FaiTypography
                                                        component="label"
                                                        variant="subtitle2"
                                                        fontWeight="bold"
                                                        textTransform="capitalize"
                                                    >
                                                        Issue Description
                                                    </FaiTypography>
                                                </FaiBox>
                                            </FaiBox>
                                        </FaiBox>
                                        <FaiBox>
                                            <FaiBox sx={{
                                                boxShadow: boxShadows.sm,
                                                padding: "5px 12px 5px 12px",
                                                borderRadius: borders.borderRadius.sm,
                                            }}>
                                                <FaiTypography component={"p"}  sx={{ fontSize: `${typography.size.sm} !important`}}>
                                                    The returned product is not in a good condition and has been worn
                                                    out by the customer.
                                                </FaiTypography>
                                            </FaiBox>
                                        </FaiBox>
                                    </FaiBox>

                                    <FaiBox mb={1}>
                                        <FaiBox ml={0.5}>
                                            <FaiBox lineHeight={0} display="inline-block">
                                                <FaiBox>
                                                    <FaiTypography
                                                        component="label"
                                                        variant="subtitle2"
                                                        fontWeight="bold"
                                                        textTransform="capitalize"
                                                    >
                                                        Product Details
                                                    </FaiTypography>
                                                </FaiBox>
                                            </FaiBox>
                                        </FaiBox>
                                        <FaiBox>
                                            <ProductDetail/>
                                        </FaiBox>
                                    </FaiBox>

                                </FaiBox>

                            </Grid>
                            <Grid item sm={12} md={6} lg={6}>

                            </Grid>
                        </Grid>
                    </FaiBox>

                </FaiBox>
            </FaiBox>
        </>
    );
}

export default ClosedIssues;
